export default __webpack_public_path__ + "static/media/c001-E-commerce-5.3f7ed13c.jpg";